<mat-card (click)="view()">
    <img *ngIf="cardDetail.IMAGE_PROFILE_URL" class="imageCover" mat-card-image [src]="cardDetail.IMAGE_PROFILE_URL" [alt]="cardDetail.IMAGE_PROFILE">
    <img *ngIf="!cardDetail.IMAGE_PROFILE_URL" class="imageCover" mat-card-image
        src="https://png.pngtree.com/png-vector/20191218/ourmid/pngtree-coming-soon-logo-vector-template-design-illustration-png-image_2091063.jpg"
        alt="Learning Center">

    <mat-card-content *ngIf="cardDetail.CENTER_NAME">
        <h2 class="text-left cut-text card-text">
            {{ cardDetail.CENTER_NAME }}
        </h2>
    </mat-card-content>

    <a (click)="view()" class="link">
        เพิ่มเติม
    </a>
</mat-card>